import { useEffect, useState } from "react";
import Logo from "../../assets/img/logo2.png"
import personIcon from "../../assets/img/profile.ea4f1c2e.svg"
import { NavLink, Outlet, matchPath, useLocation, useNavigate } from 'react-router-dom';
import { deleteAuthTokens } from "../../features/auth/authSlice";
import { useAppDispatch } from "../../app/hooks";


const MainLayout = () => {
  return (
    <div className=" h-screen  bg-body-bg sm:min-w-desktop sm:max-w-desktop md:min-w-desktop md:max-w-desktop lg:min-w-desktop lg:max-w-full xl:min-w-full xl:max-w-full  overflow-auto">
      <div className=" h-max">
        <div className="flex h-full ">
          <div className=" z-40 bg-green-700 w-[270px] min-w-[270px] border border-l-0 border-t-0 border-gray-100 fixed">
            <div className=" bg-green-800 bg-opacity-50 h-20 flex flex-col pl-edge-space justify-center  ">
              <div className="flex">
                <div className="">
                  <img className=" h-12 w-auto" src={Logo} alt="" />
                </div>
                <div className="  flex flex-col justify-center">
                  <span className="pl-[2px] text-xl font-bold text-white" style={{ fontSize: '15px' }}>ABCD ADMIN</span>
                </div>
              </div>
            </div>
            <div className="  min-h-screen flex flex-col pt-4">
              <SideItems />
            </div>
          </div>
          <div className="flex-grow ">
            <nav className="bg-white h-20 border border-t-0 border-l-0 border-r-0 border-gray-100 fixed  w-screen">
              <div className=" flex flex-col justify-center h-full ">
                <div className="col-span-2 flex flex-col justify-center pr-edge-space ">
                  <div className="flex flex-row-reverse gap-2 ">
                    <MyAccountSection />

                  </div>
                </div>
              </div>
            </nav>
            <div className=" px-5 py-4 mt-20  ml-[270px]">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainLayout;

const MyAccountSection = () => {
  const [showDropDown, setShowDropDown] = useState(false)
  const [label, setLabel] = useState("This Month")
  const navigate =useNavigate()
  const dispatch = useAppDispatch()



  const logoutUser =()=>{
    localStorage.removeItem("access_token")
    dispatch(deleteAuthTokens())
    navigate("/")
  }


  return (
    <>
      <span onClick={() => setShowDropDown(!showDropDown)} className=" hover:bg-green-600 border border-gray-200 cursor-pointer rounded-md flex justify-center h-8">
        <img className="w-5" src={personIcon} alt="" />
      </span>
      <div className={!showDropDown ? 'hidden' : '' + 'z-50 right-4 border absolute min-w-[13rem] rounded min-h-[80px] text-base list-none bg-white bg-opacity-100  shadow-2xl py-1 mt-8 overflow-y-auto'} >
        <ul className="">
          <li onClick={()=>logoutUser()} className="nav-dropdown-item text-sm text-gray-600 font-normal"> <span>Logout</span> </li>
        </ul>
      </div>
    </>
  )
}


const SideItems = () => {
  const location = useLocation();
  useEffect(() => {

  }, [location])
  const isActiveLink = (paths: string[]): string => {
    for (const str of paths) {
      if (location.pathname.includes(str)) {
        return "active";
      }
    }
    return "";
  };
  
  return (
    <ul className=" text-[15px] ">
      <li>
        <NavLink className={"nav-link " + (isActiveLink(["value-chain"]))} to="/value-chains" >
          <span className="flex">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M8.625 8.5h-4.5a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v3.5h3.5a1 1 0 0 1 0 2Z"/><path fill="currentColor" d="M21 13a1 1 0 0 1-1-1A7.995 7.995 0 0 0 5.08 8.001a1 1 0 0 1-1.731-1.002A9.995 9.995 0 0 1 22 12a1 1 0 0 1-1 1zm-1.125 9a1 1 0 0 1-1-1v-3.5h-3.5a1 1 0 0 1 0-2h4.5a1 1 0 0 1 1 1V21a1 1 0 0 1-1 1z"/><path fill="currentColor" d="M12 22A10.012 10.012 0 0 1 2 12a1 1 0 0 1 2 0a7.995 7.995 0 0 0 14.92 3.999a1 1 0 0 1 1.731 1.002A10.032 10.032 0 0 1 12 22Z"/></svg>
            <span className="pl-1">Value Chains</span>
          </span>
        </NavLink>
      </li>
      {/* <li>
        <NavLink className={"nav-link " + (isActiveLink(["data-sources"]))} to="/data-sources">
          <span className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M12 11q3.75 0 6.375-1.175T21 7q0-1.65-2.625-2.825T12 3Q8.25 3 5.625 4.175T3 7q0 1.65 2.625 2.825T12 11Zm0 2.5q1.025 0 2.563-.213t2.962-.687q1.425-.475 2.45-1.237T21 9.5V12q0 1.1-1.025 1.863t-2.45 1.237q-1.425.475-2.962.688T12 16q-1.025 0-2.563-.213T6.476 15.1q-1.425-.475-2.45-1.237T3 12V9.5q0 1.1 1.025 1.863t2.45 1.237q1.425.475 2.963.688T12 13.5Zm0 5q1.025 0 2.563-.213t2.962-.687q1.425-.475 2.45-1.238T21 14.5V17q0 1.1-1.025 1.863t-2.45 1.237q-1.425.475-2.962.688T12 21q-1.025 0-2.563-.213T6.476 20.1q-1.425-.475-2.45-1.238T3 17v-2.5q0 1.1 1.025 1.863t2.45 1.237q1.425.475 2.963.688T12 18.5Z" /></svg>
            <span className="pl-1"> Data sources</span>
          </span>
        </NavLink>
      </li>
      <li>
        <NavLink className={"nav-link " + (isActiveLink(["/create-production", "/edit-production"]))} to="/production">
          <span className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M12 3L3 8.2V21h6l2.9-3l3.1 3h6V8.2L12 3M7.9 20v-6l3 3l-3 3m1-7h6l-3 3l-3-3m7 7l-3-3l3-3v6m-.9-9H8.8V9H15v2Z" /></svg>
            <span className="pl-1">Production</span>
          </span>
        </NavLink>
      </li>
      <li>
        <NavLink className={"nav-link " + (isActiveLink(["/create-processing","/edit-processing"]))} to="/processing">
          <span className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M2 22V9.975L9 7v2l5-2v3h8v12H2Zm2-2h16v-8h-8V9.95l-5 2V10l-3 1.325V20Zm7-2h2v-4h-2v4Zm-4 0h2v-4H7v4Zm8 0h2v-4h-2v4Zm7-8h-5l1-8h3l1 8ZM4 20h16H4Z" /></svg>
            <span className="pl-1">Processing</span>
          </span>
        </NavLink>
      </li>
      <li>
        <NavLink className={"nav-link " + (isActiveLink(["selling"]))} to="/selling">
          <span className="flex">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M12 13a5 5 0 0 1-5-5h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2a5 5 0 0 1-5 5m0-10a3 3 0 0 1 3 3H9a3 3 0 0 1 3-3m7 3h-2a5 5 0 0 0-5-5a5 5 0 0 0-5 5H5c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Z"/></svg>
            <span className="pl-1">Marketing & Selling</span>
          </span>
        </NavLink>
      </li> */}
      <li>
        <NavLink className={"nav-link " + (isActiveLink(["/upload-template"]))} to="/upload-template">
          <span className="flex">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><g fill="none" fillRule="evenodd"><path d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z"/><path fill="currentColor" d="M11.5 4C8.851 4 6.739 6.38 7.027 9a1.01 1.01 0 0 1-.758 1.09A3.002 3.002 0 0 0 7 16h1a1 1 0 1 1 0 2H7a5 5 0 0 1-2-9.584a6.5 6.5 0 0 1 12.586-2.204A6.002 6.002 0 0 1 16 18a1 1 0 1 1 0-2a4 4 0 0 0 .655-7.947a1.01 1.01 0 0 1-.81-.732A4.502 4.502 0 0 0 11.5 4Zm1.5 8.416l1.293 1.292a1 1 0 0 0 1.414-1.416l-2.824-2.819a1.25 1.25 0 0 0-1.766 0l-2.824 2.82a1 1 0 0 0 1.414 1.415L11 12.416V21a1 1 0 1 0 2 0v-8.584Z"/></g></svg>
            <span className="pl-1"> Upload Templates</span>
          </span>
        </NavLink>
      </li>

      {/* <li>
        <NavLink className={"nav-link " + (isActiveLink(["/create-region"]))} to="/regions">
          <span className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24"><path fill="currentColor" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Z" /></svg>
            <span className="pl-1"> Regions</span>
          </span>
        </NavLink>
      </li> */}
      <li>
        <NavLink className={"nav-link " + (isActiveLink(["/create-admins"]))} to="/admins">
          <span className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24"><path fill="currentColor" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4Z" /></svg>
            <span className="pl-1"> User Management</span>
          </span>
        </NavLink>
      </li>
    </ul>
  );
}

type subItem = {
  text: string,
  linkRoute?: string
}

type sideLinkPropsType = {
  title: string
  subItems: subItem[],
  isActive?: string
}
const SideLink = (props: sideLinkPropsType) => {
  const [isOpen, setIsOpen] = useState(false)
  useEffect(() => {
    if (props.isActive === "active") {
      setIsOpen(true)
    }
  }, [props.isActive])
  return (
    <li>
      <a onClick={() => setIsOpen(!isOpen)} className={'nav-link ' + (isOpen ? 'bg-gray-200' : '')} href="#!"> <span className="flex" > <span className=" flex-grow">{props.title}</span>
        <span className={isOpen ? 'hidden' : ''}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z" /></svg>
        </span>
        <span className={!isOpen ? 'hidden' : ''}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M19 12.998H5v-2h14z" /></svg>
        </span>
      </span>  </a>
      <ul className={' overflow-hidden ' + (!isOpen ? 'h-0' : ' h-auto')} >
        {
          props.subItems.map((item, key) => (
            <li key={key}>
              {
                (item.linkRoute) ?
                  <NavLink className="sub-nav-link" to={item.linkRoute}>{item.text}</NavLink>
                  : <a className="sub-nav-link" href="#!" >{item.text}</a>
              }
            </li>
          ))
        }

      </ul>

    </li>
  )
}
